import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import numeral from 'numeral';
import classnames from 'classnames';
import WoffEmbeddedText from 'components/WoffEmbeddedText';

const PREVIEW_TAB_LIGHT = 'PREVIEW_TAB_LIGHT';
const PREVIEW_TAB_DARK = 'PREVIEW_TAB_DARK';

export default createReactClass({
  propTypes: {
    workingSetTypeface: ImmutablePropTypes.record.isRequired,
  },

  mixins: [ImmutableRenderMixin],

  getInitialState() {
    return {
      previewTab: PREVIEW_TAB_LIGHT,
    };
  },

  handleLightPreviewClicked(event) {
    event.preventDefault();

    this.setState({previewTab: PREVIEW_TAB_LIGHT});
  },

  handleDarkPreviewClicked(event) {
    event.preventDefault();

    this.setState({previewTab: PREVIEW_TAB_DARK});
  },

  render() {
    const {
      workingSetTypeface,
    } = this.props;
    const fullName = `${workingSetTypeface.family} ${workingSetTypeface.weight} ${workingSetTypeface.style}`;
    const isLightPreview = (this.state.previewTab === PREVIEW_TAB_LIGHT);
    const isDarkPreview = (this.state.previewTab === PREVIEW_TAB_DARK);
    const lightTabClassName = classnames('nav-item', {active: isLightPreview});
    const darkTabClassName = classnames('nav-item', {active: isDarkPreview});
    const alertClassName = classnames('well', {'bg-body': isLightPreview, 'bg-gray-dark': isDarkPreview});

    return (
      <div>
        <ul className="nav nav-tabs-inline m-xs-b-md">
          <li className={lightTabClassName}><a className="nav-link" onClick={this.handleLightPreviewClicked} href="#">Light</a></li>
          <li className={darkTabClassName}><a className="nav-link" onClick={this.handleDarkPreviewClicked} href="#">Dark</a></li>
        </ul>

        <WoffEmbeddedText woff={workingSetTypeface.woff} className={alertClassName}>
          <h1 className="text-nowrap">{fullName}</h1>
          <h2 className="text-nowrap">{fullName}</h2>
          <h3 className="text-nowrap">{fullName}</h3>
          <h4 className="text-nowrap">{fullName}</h4>
          <h5 className="text-nowrap">{fullName}</h5>
          <p className="m-xs-b-0">
            He smiled understandingly-much more than understandingly. It was one of those rare smiles with a quality
            of eternal reassurance in it, that you may come across four or five times in life. It faced–or seemed to
            face–the whole eternal world for an instant, and then concentrated on you with an irresistible prejudice in
            your favor. It understood you just as far as you wanted to be understood, believed in you as you would like
            to believe in yourself, and assured you that it had precisely the impression of you that, at your best, you
            hoped to convey.
          </p>
        </WoffEmbeddedText>

        <table className="table table-condensed m-xs-t-md text-muted">
          <tbody>
            <tr className="asset-history">
              <th scope="row" className="text-normal">Last Edited</th>
              <td>{workingSetTypeface.updatedAt.fromNow()}</td>
            </tr>

            <tr className="asset-size">
              <th scope="row" className="text-normal">File Size</th>
              <td>{numeral(workingSetTypeface.optimizedSize).format('0b')}</td>
            </tr>

            <tr className="asset-use">
              <th scope="row" className="text-normal">CSS use</th>
              <td className="p-xs-r-0">
                <div className="well pre bg-gray-dark inset-darkest font-family-monospace m-xs-b-xs p-xs-y-sm text-xs-left text-sm">
                  <div className="code code-highlight">
                    <span className="nt">.example {'{'}</span><br />
                    &nbsp;&nbsp;<span className="na">font-family:</span>&nbsp;<span className="s">{workingSetTypeface.family}</span><span className="na">;</span><br />
                    &nbsp;&nbsp;<span className="na">font-weight:</span>&nbsp;<span className="s">{workingSetTypeface.weight}</span><span className="na">;</span><br />
                    &nbsp;&nbsp;<span className="na">font-style:</span>&nbsp;<span className="s">{workingSetTypeface.style}</span><span className="na">;</span><br />
                    <span className="nt">{'}'}</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/TypefacePreview.js